// extracted by mini-css-extract-plugin
export default {"BaseButton":"BaseButton_BaseButton__JAMDW"};